import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

const Index = ({ authUser }) => {
  const { batchId = 2, batch } = authUser?.currentlyProgram.batch || {};
  const [timeline, setTimeline] = useState([]);
  const [loadingKeys, setLoadingKeys] = useState([]);
  const [statusAcceptance, setStatusAcceptance] = useState([]);
  const [statusAcceptanceProgress, setStatusAcceptanceProgress] = useState(0);

  useEffect(() => {
    const getTimelineByBatchId = async () => {
      const data = await api.getTimelineByBatchId({ batchId });
      setTimeline(data);
    };

    const getStatusAcceptance = async () => {
      const data = await api.getStatusAcceptance();

      const totalSteps = data.length;

      // Cari index terakhir yang isChecked === 1
      const lastCheckedIndex = [...data]
        .reverse()
        .findIndex((item) => item.isChecked === 1);

      const index =
        lastCheckedIndex === -1 ? 0 : totalSteps - 1 - lastCheckedIndex;

      const progress = (index / (totalSteps - 1)) * 100;

      setStatusAcceptance(data);
      setStatusAcceptanceProgress(progress);
    };

    getTimelineByBatchId();
    getStatusAcceptance();
  }, []);

  const lastChecked = [...statusAcceptance]
    .reverse()
    .find((value) => value.isChecked);

  return (
    <div className="row g-3">
      <div className="col-12 col-md-6">
        <div className="card">
          <div className="card-body">
            <h1 className="mb-3 h5">Timeline Magang CLP {batch}</h1>

            <div class="list-group">
              {timeline.map((value, key) => (
                <label
                  class={`list-group-item d-flex gap-3 py-3 ${
                    !value.activeStatus.status && 'bg-body-tertiary'
                  }`}
                  key={key}
                >
                  <div className="d-flex gap-2 w-100 justify-content-between">
                    <span class="pt-1 form-checked-content">
                      <strong>{value.title}</strong>
                      <small class="d-block text-body-secondary">
                        {value.startDate} - {value.endDate}
                      </small>
                    </span>
                    <div className="d-flex align-items-center">
                      <span
                        class={`badge rounded-pill ${
                          value.activeStatus.status
                            ? 'text-bg-primary'
                            : 'text-bg-success'
                        }`}
                      >
                        {value.activeStatus.message}
                      </span>
                    </div>
                  </div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-md-6">
        <div className="card">
          <div className="card-body">
            <h1 className="mb-3 h5">Status Penerimaan</h1>

            <div class="position-relative m-4">
              <div className="position-relative m-4" style={{ height: '3rem' }}>
                {/* Garis background */}
                <div
                  className="position-absolute top-50 start-0 w-100"
                  style={{
                    height: '4px',
                    backgroundColor: '#dee2e6', // abu muda
                    transform: 'translateY(-50%)',
                    zIndex: 1,
                  }}
                >
                  {/* Garis progress dinamis */}
                  <div
                    style={{
                      height: '100%',
                      width: `${statusAcceptanceProgress}%`, // pastikan ini sesuai
                      backgroundColor: '#0d6efd', // biru
                    }}
                  />
                </div>

                {/* Tombol status */}
                <div
                  className="position-absolute top-50 start-0 w-100 d-flex justify-content-between"
                  style={{ transform: 'translateY(-50%)', zIndex: 2 }}
                >
                  {statusAcceptance?.map((value, key) => {
                    const isGreen = [4, 6].includes(
                      value.statusAcceptanceProgramId
                    );
                    const btnClass = value.isChecked
                      ? isGreen
                        ? 'btn-success'
                        : 'btn-primary'
                      : 'btn-secondary';

                    return (
                      <button
                        key={key}
                        type="button"
                        className={`btn btn-sm ${btnClass} rounded-pill`}
                        style={{
                          width: '2rem',
                          height: '2rem',
                          zIndex: 3,
                        }}
                      >
                        {value.statusAcceptanceProgramId}
                      </button>
                    );
                  })}
                </div>
              </div>

              {lastChecked && (
                <>
                  <div
                    className={`alert ${
                      lastChecked.isChecked
                        ? lastChecked.statusAcceptanceProgramId === 4 ||
                          lastChecked.statusAcceptanceProgramId === 6
                          ? 'alert-success'
                          : 'alert-primary'
                        : 'alert-secondary'
                    }`}
                    role="alert"
                  >
                    {lastChecked.note}
                  </div>
                  <span>
                    <small class="d-block text-body-secondary">
                      Last Updated: <strong>{lastChecked.lastUpdated}</strong>
                    </small>
                    {lastChecked.updatedBy.firstName !== '' &&
                      lastChecked.updatedBy.lastName !== '' && (
                        <small class="d-block text-body-secondary">
                          Updated By:{' '}
                          <strong>
                            {`${lastChecked.updatedBy.firstName} ${lastChecked.updatedBy.lastName}`}
                          </strong>
                        </small>
                      )}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
